/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2025 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import {
  ConfigurationPrintOptionDto,
  PrintOptionDto2,
  VariantDto,
} from '@/api-sdk';
import { createContext } from '@lit/context';
import { LitElement } from 'lit';

export interface VisualDesignerContextType {
  productId: string;
  productName: string;
  price?: string;
  variant?: VariantDto | null;
  selectedPrintOptions?: ConfigurationPrintOptionDto[] | null;
  printOptions?: PrintOptionDto2[];
}

export const visualDesigner = {
  context: createContext<VisualDesignerContextType>(Symbol('ComponentContext')),
  providerUpdateEvent(
    element: LitElement,
    visualDesignerData: Partial<VisualDesignerContextType>,
  ) {
    element.dispatchEvent(
      new CustomEvent('visual-designer-context-update', {
        composed: true,
        detail: { visualDesignerData },
      }),
    );
  },
  providerRemoveSelectedPrintOptionEvent(
    element: LitElement,
    visualDesignerContext: VisualDesignerContextType,
    printOptionCode: string,
  ) {
    visualDesignerContext.selectedPrintOptions =
      visualDesignerContext.selectedPrintOptions?.filter(
        printOption => printOption.code !== printOptionCode,
      );

    element.dispatchEvent(
      new CustomEvent('visual-designer-context-update', {
        composed: true,
        detail: { visualDesignerData: visualDesignerContext },
      }),
    );
  },
};
